<template>
<div class="after-sale-list list-common">
  <!-- 筛选条件 -->
  <div class="query-div">
    <!-- 已选条件 -->
    <div class="selected-div">
      <div class="title text-red">售后处理</div>
    </div>
    <div>
    <p class="sub-title">请选择你需要的退款类型</p>
    <div class="flex-between">
        <div class="flex">
          <div class="type-btn" :class="typeIndex === 2 ? 'active':''" @click="handleChangeType(2)">退款退货</div>
          <div class="type-btn" :class="typeIndex === 3 ? 'active':''" @click="handleChangeType(3)">仅退款</div>
          <div class="type-btn" :class="typeIndex === 1 ? 'active':''" @click="handleChangeType(1)">换货</div>
        </div>
        <div class="after-record" @click="handleRecord">
          <span>售后记录</span>
          <i class="right"></i>
        </div>
    </div>
    </div>
    <div v-if="orderList.length > 0" class="mt10">
      <div class="flex order-list" v-for="item in orderList" :key="item.aftersalesId">
        <img class="order-img" :src="item.goodsList && item.goodsList.length > 0 && item.goodsList[0].goodsThumbnail" alt="">
        <div class="flex-1">
          <div class="flex-align-center mb20">
            <p class="order-title mr20">{{ item.merchIndustryName }}</p>
            <p class="order-time">下单时间：</p>
            <p class="order-time-black">{{ item.orderTime }}</p>
          </div>
          <div class="flex-between">
            <div>
              <div class="flex-align-center" v-for="(subItem, subIdx) in item.goodsList" :key="subItem.goodsId">
                <p v-if="subIdx < 2" class="order-goods">{{ subItem.goodsName }}</p>
                <p v-if="subIdx < 2" class="order-quantity">数量：<span>{{ subItem.quantity }}</span></p>
              </div>
              <img v-if="item.goodsList && item.goodsList.length > 2" src="../../assets/images/dot.png" alt="">
            </div>
            <div class="order-pay">实付款：¥{{ item.itemTotal }}({{ item.payTypeName }})</div>
            <div class="order-status">{{ item.aftersalesStatusName || item.statusName }}</div>
            <div style="width:150px" class="text-right">
              <!-- 确认收货后，不能申请售后 -->
              <el-button v-if="typeIndex === 2 && item.aftersalesStatus !== 0 && item.orderStatus !== 36" :disabled="item.orderStatus === 28" class="red-line" @click="handleApply(item)">申请退货</el-button>
              <el-button v-if="typeIndex === 3 && item.aftersalesStatus !== 0 && item.orderStatus !== 36" :disabled="item.orderStatus === 28" class="red-line" @click="handleApply(item)">申请退款</el-button>
              <el-button v-if="typeIndex === 1 && item.aftersalesStatus !== 0 && item.orderStatus !== 36" :disabled="item.orderStatus === 28" class="red-line" @click="handleApply(item)">申请换货</el-button>
              <el-button v-if="item.aftersalesStatus !== null && item.aftersalesStatus !== 2 && item.aftersalesStatus !== 4" class="red-line" :class="{mt10: item.aftersalesStatus !== 0}" @click="handleStep(item)">查看售后进度</el-button>
              <p v-if="item.orderStatus === 28" class="unRefund">已过售后期</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-data">暂无数据</div>
    <div class="pagination-self" v-if="orderList.length > 0">
        <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="totalCount"
        >
        </el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { loadOrderList } from '@/api/afterSales'
import { afterSalesMixin } from '@/mixins/afterSalesMixin'
export default {
  name: 'afterSalesOrderList',
  mixins: [afterSalesMixin],
  data () {
    return {
      typeIndex: 2,
      page: 1,
      limit: 10,
      orderList: [],
      totalCount: 0
    }
  },
  created () {
    this.$nextTick(() => {
      this.loadList()
    })
  },
  methods: {
    // 售后分页列表
    loadList () {
      const param = {
        page: this.page,
        limit: this.limit,
        status: this.typeIndex === 3 ? 'ONLY_REFUND' : 'AFTERSALES'
      }
      loadOrderList(param).then(res => {
        if (res.code === 0) {
          this.orderList = res.data.list
          this.totalCount = res.data.totalCount
        }
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.loadList()
    },
    // 切换售后类型
    handleChangeType (type) {
      this.typeIndex = type
      this.page = 1
      this.loadList()
    },
    // 售后记录
    handleRecord () {
      this.$router.push({
        path: 'afterSalesRecord',
        query: { moduleType: 'RETAIL' }
      })
    },
    // 申请售后
    handleApply (info) {
      this.$router.push({
        path: 'afterSalesApply',
        query: {
          uniteOrderNo: info.uniteOrderNo,
          orderStatus: info.orderStatus,
          typeIndex: this.typeIndex,
          moduleType: 'RETAIL'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/common/css/afterSales.scss';
</style>
